import {
  Flex,
  Icon,
  Text,
  Button,
  Spacer,
} from '@sendoutcards/quantum-design-ui'
import { useActions, useEffect } from 'src/hooks'

export function ActError(props: { code: number }) {
  const actions = useActions()
  function renderMsg(code: number) {
    switch (code) {
      case 1001:
        return 'ACT has expired and is no longer accessible'
      case 1002:
        return 'No ACT token was provided'
      case 1003:
        return 'The ACT token you supplied is invalid, please try a different token'
      default:
        return 'An unexpected error has occured'
    }
  }

  useEffect(() => {
    console.error(renderMsg(props.code))
  }, [props.code])

  return (
    <Flex
      width="100%"
      height="100%"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      inset={{ horizontal: 'x2' }}
    >
      <Icon name="exclamation" primaryColor={'danger'} size={120} />
      <Text
        type={{ xSmall: 'subtitle', small: 'title' }}
        outset={{ bottom: 'x_5' }}
      >
        Failed to retrieve ACT
      </Text>
      <Text type={{ xSmall: 'body', small: 'subtitle' }} alignment="center">
        {renderMsg(props.code)}
      </Text>
      <Spacer space="x4" />
      <Button type="danger" outlined onClick={() => actions.openAccount()}>
        Return to Account
      </Button>
    </Flex>
  )
}
